<template>
  <ul class="apartment-search-count" role="list">
    <li v-for="item in filteredApartmentCountData" :key="item.type">
      {{ item.name }}: <strong>{{ item.count }}</strong>
    </li>
  </ul>
</template>

<script>

import utils from '../mixins/utils';


export default {
  name: 'ApartmentCountPerType',
  mixins: [utils.translate],
  props: {
    apartmentCountData: {
      type: Array,
      required: true
    },
    apartmentCounts: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedTypes: [],
    }
  },
  computed: {
    filteredApartmentCountData() {
      const keys = Object.keys(this.apartmentCounts);
      return this.apartmentCountData
        .map((item, index) => ({ ...item, type: keys[index] }))
        .filter(item => this.selectedTypes.length === 0 || this.selectedTypes.includes(item.type));
    }
  },
  created() {
    // Get URL parameters string.
    const params = new URLSearchParams(window.location.search)

    // Get the value of the 'q' URL parameter.
    const q = params.get('q')

    if (q) {
      try {
        // Decode the URL-encoded string and parse it as JSON.
        const decoded = decodeURIComponent(q)
        const parsed = JSON.parse(decoded)

        // Extract the 'type' property from the parsed object.
        this.selectedTypes = parsed.type || []
      } catch (err) {
        console.warn('Failed to parse apartment type from query string:', err)
      }
    }
  }
}

</script>

<style lang="scss">
  @import "~styles/definitions";

  .apartment-search-count {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    gap: 1rem;
    margin-top: .5rem;
    flex-wrap: wrap;

    @include media-breakpoint-down(sm) {
      gap: .5rem 1rem;
    }

    li {
      font-size: 0.75rem;
      text-transform: uppercase;
      line-height: 1rem;
      font-weight: normal;
    }
  }

</style>
